import React, { useState, useMemo, useRef, useEffect } from "react";
import styled from 'styled-components';
import { ManageStaffTable } from "./ManageStaff/ManageStaffTable";
import { EditStaffDialog } from "./ManageStaff/EditStaffDialog";
import { colors } from "../../Shared/colors";
import {
  useAssignStaffLeadsMutation,
  useBlockStaffMutation,
  useEditStaffMutation,
  useGetStaffQuery,
} from "../../features/employeeSlice";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Toaster, toast } from "react-hot-toast";
import { useGetAllRegionQuery } from "../../features/regionSlice";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { usePaginationFromURL } from "../../hooks/usePaginationFromURL";
import {
  STAFF_STATUS,
  countStaffByStatus,
  filterActiveStaff,
  getStaffStatus,
} from "../../Shared/staffStatus";

export const StaffDataTable = ({ filters = {}, tab = STAFF_STATUS.ACTIVE, onTabChange = () => {} }) => {
  // Use URL-based pagination hook (Note: DataGrid uses 0-indexed pages for client-side pagination)
  const { currentPage: urlPage, pageSize, setPage: setUrlPage, setPageSize } = usePaginationFromURL({
    defaultPage: 1,
    defaultPageSize: 50
  });
  // Convert to 0-indexed for DataGrid (client-side pagination)
  const currentPage = urlPage - 1;
  const setCurrentPage = (page) => {
    const pageNum = typeof page === 'function' ? page(currentPage) : page;
    setUrlPage(pageNum >= 0 ? pageNum + 1 : 1);
  };
  const [popUp, setpopUp] = useState(false);
  const [blockPopUp, setblockPopUp] = useState(false);
  const [historypopup, setHistorypopUp] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [staffId, setstaffId] = useState(null);
  const [newEmployeeId, setnewEmployeeId] = useState("");
  const [Password, setPassword] = useState("");
  const fileInputRef = useRef(null)

  const [assignLeads, setassignLeads] = useState(false);

  // The full roster, every state — this is the one screen whose job is to show
  // blocked and removed people. `getStaff` now provides the "Employee" tag, so
  // blocking, editing and removing refresh it on their own; the manual refetch
  // that used to follow every mutation was a second request for the same data.
  const { data: staff, isFetching } = useGetStaffQuery();
  const [editStaff, { isLoading }] = useEditStaffMutation();
  const [blockStaff, { isLoading: isBlockLoading }] = useBlockStaffMutation();
  const [assignStaffLeads, { isLoading: assignLeadsLoading }] =
    useAssignStaffLeadsMutation();

  let { data: region } = useGetAllRegionQuery();

  const [staffData, setstaffData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    phoneNum: null,
    cnic: null,
    address: "",
    gender: "",
    designation: "",
    profilePic: null,
    region: "",
    assignArea: "",
    role: "",
    empID: "",
  });
  const handleStaffChange = (e) => {
    const { name, value, type, files } = e.target;
    setstaffData((prevData) => ({
      ...prevData,
      [name]: type === 'file' ? files[0] : value,
    }));
  };

  const handleProfilePicChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setstaffData((prevstate) => ({
        ...prevstate,
        profilePic: file,
      }));
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };


  const handleStaffSave = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("firstName", staffData.firstName);
    formData.append("lastName", staffData.lastName);
    formData.append("email", staffData.email);
    if (Password) {
      formData.append("password", Password);
    }
    formData.append("phoneNum", staffData.phoneNum);
    formData.append("cnic", staffData.cnic);
    formData.append("address", staffData.address);
    formData.append("gender", staffData.gender);
    formData.append("designation", staffData.designation);
    formData.append("region", staffData.region);
    formData.append("assignArea", staffData.assignArea);
    formData.append("role", staffData.role);
    formData.append("empID", staffData.empID);
    if (staffData.profilePic instanceof File) {
      formData.append("profilePic", staffData.profilePic);
    }
    try {
      const response = await editStaff({ staffId, formData }).unwrap();
      if (response.success) {
        toast.success("Staff Updated Successfully");
        setpopUp(false);
        setPassword("");
      } else {
        toast.error("Error updating staff");
      }
    } catch (err) {
      toast.error("Error updating staff");
      console.error(err);
    }
  };

  useEffect(() => {
    if (staffId) {
      const staffToEdit = staff.find(staff => staff?._id === staffId);
      if (staffToEdit) {
        setstaffData(staffToEdit);
      }
    }
  }, [staffId, staff]);

  const handleBlockStaff = (e) => {
    e.preventDefault();
    // The endpoint toggles, so what just happened is the opposite of what they
    // were. Reporting "Blocked successfully" after an unblock was a small lie
    // that mattered: the row also leaves the tab you are on, and the toast was
    // the only explanation of where it went.
    const wasBlocked = Boolean(selectedStaff?.block);
    blockStaff({ staffId })
      .unwrap()
      .then(() => {
        toast.success(
          wasBlocked
            ? "Unblocked. They can log in again and now appear under Active."
            : "Blocked. They cannot log in and now appear under Blocked."
        );
      })
      .catch((error) => {
        toast.error(error?.data?.error?.message || "Could not change their access");
      });
    setblockPopUp(false);
  };

  // const handleBlockStaff = (e) => {
  //   e.preventDefault();

  //   // Determine if we are blocking or unblocking
  //   const isBlocked = !selectedStaff?.block; // If currently blocked, we want to unblock (false), and vice versa

  //   blockStaff({ staffId, isBlocked })
  //     .unwrap()
  //     .then((res) => {
  //       toast.success(`Staff ${isBlocked ? "Blocked" : "Unblocked"} Successfully`);
  //       refetch();
  //     })
  //     .catch((error) => {
  //       toast.error(error?.data?.error?.message);
  //     });

  //   setblockPopUp(false);
  // };

  const handelAssignLeads = (e) => {
    e.preventDefault();
    let data = {
      newEmployeeId: newEmployeeId.id,
    };

    assignStaffLeads({ staffId, data })
      .unwrap()
      .then((res) => {
        toast.success("Leads assign successfully");
      })
      .catch((error) => {
        setblockPopUp(false);
        setnewEmployeeId("");
        setstaffId("");
        toast.error(error?.data?.error?.message);
      });
  };
  // Handing this person's leads over is only meaningful if the recipient can
  // actually log in and work them, so the picker never offers someone blocked
  // or already gone.
  const options = useMemo(
    () =>
      filterActiveStaff(staff)
        .filter((s) => s?._id !== staffId)
        .map((s) => ({
          id: s?._id,
          label: `${s?.firstName || ""} ${s?.lastName || ""}`.trim(),
        })),
    [staff, staffId]
  );

  // Counts come from the whole roster, not the filtered slice: a tab badge has
  // to say how many people are in that state, not how many survive whatever is
  // currently typed in the search box.
  const counts = useMemo(() => countStaffByStatus(staff), [staff]);

  /**
   * What the table shows: the selected tab, narrowed by the filter bar.
   *
   * Applied here rather than inside the table so the table stays a
   * presentation component and the page keeps one source of truth.
   */
  const visibleStaff = useMemo(() => {
    const { search = "", role = "", region = "" } = filters || {};
    const needle = search.trim().toLowerCase();

    return (staff || []).filter((s) => {
      if (getStaffStatus(s) !== tab) return false;

      if (needle) {
        const haystack = [
          s.firstName,
          s.lastName,
          `${s.firstName || ""} ${s.lastName || ""}`,
          s.email,
          s.empID,
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();
        if (!haystack.includes(needle)) return false;
      }

      if (role && s.role !== role) return false;
      // region can arrive populated or as a raw id, so compare both shapes.
      if (region && String(s.region?._id || s.region || "") !== String(region)) return false;
      return true;
    });
  }, [staff, filters, tab]);

  const hasFilters = Boolean(
    (filters?.search || "").trim() || filters?.role || filters?.region
  );

  // Typing in the search box shrinks the list under whatever page you were on.
  // Left alone, DataGrid honours a page number that no longer exists and shows
  // an empty table with results sitting one page back — which reads as "no
  // matches". Clamping instead of resetting keeps your place when the list is
  // still long enough to hold it.
  const lastPage = Math.max(0, Math.ceil(visibleStaff.length / pageSize) - 1);
  const safePage = Math.min(currentPage, lastPage);

  return (
    <Main>
      {/*
        Table lives in ManageStaffTable; this stays the container that owns the
        edit, block and history dialogs. URL pagination is preserved — the hook
        is 1-indexed, DataGrid is 0-indexed, converted above.
      */}
      <ManageStaffTable
        staff={visibleStaff}
        // The removal dialog picks who inherits the work, so it needs the whole
        // roster — not the slice the current tab happens to be showing. Passing
        // the visible rows left the Blocked and Removed tabs with nobody
        // eligible to receive anything.
        allStaff={staff}
        counts={counts}
        tab={tab}
        onTabChange={onTabChange}
        hasFilters={hasFilters}
        isFetching={isFetching}
        page={safePage}
        onPageChange={setCurrentPage}
        pageSize={pageSize}
        onPageSizeChange={(size) => {
          setPageSize(size);
          setCurrentPage(0);
        }}
        onEdit={(row) => {
          setstaffId(row.id);
          setpopUp(true);
        }}
        onToggleBlock={(row) => {
          setstaffId(row.id);
          // The block dialog reads `block`; the API returns `isBlock`.
          setSelectedStaff({ ...row, block: row.isBlock });
          setblockPopUp(true);
        }}
      />
      <EditStaffDialog
        open={popUp}
        staffData={staffData}
        region={region}
        isLoading={isLoading}
        password={Password}
        onPasswordChange={(e) => setPassword(e.target.value)}
        onChange={handleStaffChange}
        onProfilePicChange={handleProfilePicChange}
        fileInputRef={fileInputRef}
        onSave={handleStaffSave}
        onClose={() => {
          setpopUp(false);
          setPassword("");
        }}
      />

      <PopUpContainer popUp={blockPopUp}>
        <PopUp style={{ height: "50%" }}>
          <Cross onClick={() => setblockPopUp(!blockPopUp)}>
            <img
              src="/assets/icons/cross.png"
              alt="cross"
              style={{ height: "50%" }}
            />
          </Cross>
          <PopUpSection>
            <BlockPopUpSection>
              <BlockSection>
                <h3>
                  {selectedStaff && selectedStaff.block
                    ? "Do You Want To Un-Block This Staff Member?"
                    : "Do You Want To Block This Staff Member?"}
                </h3>
                <BlockButtons>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setblockPopUp(false);
                      setnewEmployeeId("");
                      setstaffId("");
                    }}
                  >
                    No
                  </button>
                  <button
                    style={{
                      backgroundColor: `${colors.hot}`,
                      color: `${colors.white}`,
                    }}
                    onClick={handleBlockStaff}
                    disabled={isBlockLoading}
                  >
                    {isBlockLoading ? (
                      selectedStaff?.block ? <>Unblocking...</> : <>Blocking...</>
                    ) : (
                      selectedStaff?.block ? <>Unblock</> : <>Block</>
                    )}
                  </button>
                </BlockButtons>
              </BlockSection>
              {!selectedStaff?.block && (
                <CheckSection>
                  <h4>Do you want to assign leads to another staff member?</h4>
                  <input
                    type="checkbox"
                    name="block"
                    onChange={(e) => setassignLeads(!assignLeads)}
                  />
                </CheckSection>
              )}
              <BlockSection>
                {assignLeads ? (
                  <>
                    <AutocompleteSection>
                      <AutoCompleteInput>
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          options={options}
                          // value={kpiData.staff}
                          isOptionEqualToValue={(option, value) => {
                            return option.id === value.id;
                          }}
                          onChange={(event, newvalue) => {
                            // setkpiData({ ...kpiData, staff: newvalue })
                            setnewEmployeeId(newvalue);
                          }}
                          getOptionLabel={(option) => {
                            if (typeof option === "string") {
                              return option;
                            } else if (
                              typeof option === "object" &&
                              option !== null &&
                              option.hasOwnProperty("label")
                            ) {
                              return option.label;
                            } else if (
                              typeof option === "object" &&
                              option !== null &&
                              option.hasOwnProperty("id")
                            ) {
                              return option.id;
                            } else {
                              return "";
                            }
                          }}
                          style={{
                            width: "100%",
                            borderRadius: "5px",
                            height: "2.9em",
                            overflow: "hidden",
                            border: `1px solid ${colors.inputBorderWhite}`,
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              sx={{
                                backgroundColor: `${colors.white}`,
                                height: "2.9em",
                              }}
                            />
                          )}
                        />
                      </AutoCompleteInput>
                    </AutocompleteSection>
                    <BlockButtons>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          setblockPopUp(false);
                          setnewEmployeeId("");
                          setstaffId("");
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        style={{
                          backgroundColor: `${colors.cold}`,
                          color: `${colors.white}`,
                        }}
                        disabled={assignLeadsLoading}
                        onClick={handelAssignLeads}
                      >
                        {assignLeadsLoading ? <>Assigning...</> : <>Assign</>}
                      </button>
                    </BlockButtons>
                  </>
                ) : null}
              </BlockSection>
            </BlockPopUpSection>
          </PopUpSection>
        </PopUp>
      </PopUpContainer>
      <PopUpContainerhis popUp={historypopup}>
        <PopUphis>
          <Cross onClick={() => setHistorypopUp(false)}>
            <img src="/assets/icons/cross.png" alt="close" />
          </Cross>
          <Sectionhis>
            <h2>Login History</h2>
            {staffId?.loginHistory?.length > 0 ? (
              <HistoryList>
                {staffId.loginHistory.map((history, index) => (
                  <HistoryItem key={index}>
                    <p>
                      <strong>Login Time:</strong>{" "}
                      {new Date(history?.loginTime).toLocaleString()}
                    </p>
                    <p>
                      <strong>IP Address:</strong> {history?.deviceInfo?.ipAddress}
                    </p>
                    <p>
                      <strong>Device Name:</strong> {history?.deviceInfo?.userAgent}
                    </p>
                    <p>
                      <strong>Device Type:</strong> {history?.deviceInfo?.deviceType}
                    </p>
                  </HistoryItem>
                ))}
              </HistoryList>
            ) : (
              <NoHistory>No login history available.</NoHistory>
            )}
          </Sectionhis>
        </PopUphis>
      </PopUpContainerhis>

      <Toaster />
    </Main>
  );
};

const Main = styled.div`
  /* Width and vertical rhythm come from the page (StaffComponent). This block
     previously set width: 90%, a 24px radius and declared margin twice — the
     second declaration killed the centering — so it never aligned with the
     filter card above it. */
  width: 100%;
`;













const BlockPopUpSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  padding: 10px;
`;

const BlockButtons = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 5%;
  button {
    min-width: 8em;
    padding: 1em 2em;
    border-radius: 5px;
    min-width: 8em;
    outline: none;
    border: none;
    background-color: ${colors.inputWhite};
    cursor: pointer;
  }
`;

const BlockSection = styled.div`
  /* min-height: 50%; */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: center;
`;

const CheckSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  input {
    margin-left: 1em;
    margin-top: 5px;
  }
`;

const AutocompleteSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AutoCompleteInput = styled.div`
  width: 65%;
`;




const PopUpContainerhis = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  visibility: ${({ popUp }) => (popUp ? "visible" : "hidden")};
  opacity: ${({ popUp }) => (popUp ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
`;

const PopUphis = styled.div`
  background: #fff;
  border-radius: 10px;
  width: 80%;
  max-width: 600px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  padding: 20px;
  position: relative;
`;

const Sectionhis = styled.div`
  max-height: 400px;
  overflow-y: auto;

  h2 {
    font-size: 1.5rem;
    margin-bottom: 20px;
    color: #333;
  }
`;

const HistoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const HistoryItem = styled.div`
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

  p {
    margin: 5px 0;
    font-size: 1rem;
    color: #555;

    strong {
      color: #333;
    }
  }
`;

const NoHistory = styled.p`
  text-align: center;
  font-size: 1.3rem;
  color: #888;
  margin-top: 20px;
`;

const PopUpContainer = styled.div`
  background-color: #0000004d;
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0vh;
  left: 0;
  z-index: 11;
  position: fixed;
  display: ${(porps) => (porps.popUp ? "flex" : "none")};
  justify-content: center;
  align-items: center;
`;

const PopUp = styled.div`
  width: 50%;
  height: 90%;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 5px;
  overflow: scroll;
`;

const Cross = styled.div`
  width: 100%;
  height: 5%;
  margin-top: 1em;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 2em;
  img {
    height: 100%;
    object-fit: contain;
    cursor: pointer;
  }
`;

const PopUpSection = styled.form`
  height: calc(100% - 10%);
  display: flex;
  justify-content: space-between;
`;
